import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { POLL_INTERVAL } from "../../constants";
import { PaymentSchedule } from "../../graphql/payment_schedule.datatypes";

interface PaymentScheduleData {
    paymentSchedule: PaymentSchedule;
}

export const gqlPaymentSchedule = `
    id
    description
    dates {
        id
        title
        due_date
        action_type
        amount
        amount_type
        completed
        calculatedAmount
    }

    tour {
        id
    }
    group {
        id
    }
    billing_party {
        id
    }
`;

export const GET_PAYMENT_SCHEDULE_QUERY = gql`
    query getPaymentSchedule($id: Int!){
        paymentSchedule(id: $id){
          ${gqlPaymentSchedule}
        }
    }
`;

export const getPaymentSchedule = (id: number) => {
    return useQuery<PaymentScheduleData>(GET_PAYMENT_SCHEDULE_QUERY, {
        variables: { id },
        fetchPolicy: "network-only",
        pollInterval: POLL_INTERVAL
    });
};

export default getPaymentSchedule;
